<template>
  <v-container fluid>

    <PageTitle icon="fal fa-fw fa-users">
      New Email List
    </PageTitle>

    <v-form @submit.prevent="submit"
            :disabled="form.busy">

      <v-card>
        <v-card-text>
          <v-text-field v-model="form.name"
                        label="List name"
                        outlined
                        :rules="[rules.required]"
                        :error-messages="form.errors.get('name')">
          </v-text-field>

          <v-text-field v-model="form.description"
                        label="Description"
                        outlined
                        maxlength="500"
                        counter="500"
                        :error-messages="form.errors.get('description')">
          </v-text-field>
        </v-card-text>
        <v-card-actions class="px-4">
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy">
            Create List
          </v-btn>
          <v-btn :to="{name: `${$root.routePrefix}.mailcoach.lists`}">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import userContactService from '../../services/userContactService';
import formValidation from '../../plugins/formValidation';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle},
  mixins: [formValidation],
  data() {
    return {
      form: new Form({
        name: '',
        description: '', // MLD-5213
        contacts: [],
      }),
      loading: false,
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isMember',
      'team',
      'user',
    ]),
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      userContactService.getContacts({})
        .then(data => {
          this.contacts = data;
        })
        .finally(() => {
          this.loading = false;
        })
    },
    submit() {
      this.form.post(`/api/mailcoach/lists`)
        .then(response => {
          const list = response.data;
          this.$router.push({name: `${this.$root.routePrefix}.mailcoach.list.edit`, params: {listID: list.id}});
        })
    }
  }
}
</script>
